import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "cdn-gatekeeper-responses",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "One protected event's automated CDN Gatekeeper response outcomes.",
    domain: "reports",
    visual: "Timeline",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "list" },
  defaultLayoutClassName: "col-span-12 xl:col-span-6",
};
